// extracted by mini-css-extract-plugin
export var container = "_68-0";
export var fallback = "_68-5";
export var fallbackIcon = "_68-6";
export var hidden = "_68-2";
export var image = "_68-3";
export var loaded = "_68-4";
export var placeholder = "_68-1";